// src/data/termsAndConditions.js
const termsAndConditions = {
  title: "Hazer Global – Terms & Conditions",
  meta: {
    effectiveDate: "February 16, 2026",
    country: "Pakistan",
  },
  sections: [
    {
      heading: "1. Acceptance of Terms",
      body:
        "By creating an account or using Hazer Global’s website or mobile application (the “Platform”), you agree to comply with and be legally bound by these Terms & Conditions. If you do not agree, please do not register or use the Platform.",
    },
    {
      heading: "2. Description of Services",
      body:
        "Hazer Global provides a digital platform that connects users with independent service providers such as electricians, plumbers, technicians, and other professionals. The company facilitates booking and payment processing but does not directly provide services unless explicitly stated.",
    },
    {
      heading: "3. User Registration & Account Responsibility",
      body:
        "Users must provide accurate and complete information during registration. You are responsible for maintaining the confidentiality of your login credentials. Hazer Global reserves the right to suspend or terminate accounts providing false information or misusing the Platform.",
    },
    {
      heading: "4. Booking & Payments",
      body:
        "All bookings are subject to availability and confirmation. Users agree to pay applicable fees at the time of booking. Cancellation and refund policies will be displayed before confirmation. Service or platform fees may apply where applicable.",
    },
    {
      heading: "5. Service Provider Responsibility",
      body:
        "Service providers are independent contractors and not employees of Hazer Global. Providers are responsible for delivering services professionally and in compliance with Pakistani laws. Hazer Global does not guarantee service quality but may monitor performance.",
    },
    {
      heading: "6. User Conduct",
      body:
        "Users agree not to misuse the Platform, provide false information, engage in unlawful activity, or harass service providers. Violations may result in suspension or permanent removal of the account.",
    },
    {
      heading: "7. Ratings & Reviews",
      body:
        "Users may submit honest reviews based on actual service experiences. Ma Hazer Global reserves the right to remove inappropriate, defamatory, or misleading reviews.",
    },
    {
      heading: "8. Cancellations & Refunds",
      body:
        "Cancellations are subject to the cancellation policy shown at booking. Refunds, if applicable, will be processed in accordance with company policy. Completed services are generally non-refundable unless a dispute is validated.",
    },
    {
      heading: "9. Limitation of Liability",
      body:
        "Ma Hazer Global shall not be liable for indirect or consequential damages, service delays, or disputes between users and service providers. Use of the Platform is at your own risk.",
    },
    {
      heading: "10. Privacy Policy",
      body:
        "By registering, you agree to the Privacy Policy outlining how personal data is collected, stored, and processed in accordance with applicable Pakistani data protection regulations.",
    },
    {
      heading: "11. Intellectual Property",
      body:
        "All trademarks, logos, content, and software on the Platform are the property of Ma Hazer Global and may not be reproduced or distributed without written permission.",
    },
    {
      heading: "12. Governing Law",
      body:
        "These Terms & Conditions shall be governed by and interpreted in accordance with the laws of the Islamic Republic of Pakistan. Any disputes shall be subject to the jurisdiction of the courts of Pakistan.",
    },
    {
      heading: "13. Modifications to Terms",
      body:
        "Ma Hazer Global reserves the right to modify these Terms at any time. Continued use of the Platform after changes constitutes acceptance of the revised Terms.",
    },
    {
      heading: "14. Contact Information",
      body:
        "For questions regarding these Terms & Conditions, please contact:",
    },
  ],
  contact: {
    company: "Ma Hazer Global",
    email: "info@mahazerglobal.com",
    phone: "+92-XXX-XXXXXXX",
    address: "Pakistan",
  },
  footerNote:
    "By clicking 'Register' or 'Create Account,' you confirm that you have read, understood, and agree to these Terms & Conditions.",
};

export default termsAndConditions;